import React from 'react';
import {Button} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import {WhiteRabbitClient} from '@whiterabbitjs/client';

import {axiosInstance} from 'utils/auth.service';

import './renting.scss';

const client = new WhiteRabbitClient({
  env: 'test',
  campaign: '25h',
});

function WRRenting({vod, cinemaId, rental}) {
  const imdbID = vod?.film?.imdb_id;
  const {t} = useTranslation();

  const handleClick = async () => {
    if (rental) return;

    // else rent the movie
    const data = await client.requestPayment(imdbID);
    const json = await data.json();
    axiosInstance
      .post('/users/rentals', {
        payment_id: json.paymentId,
        cinema_id: cinemaId,
        withCredentials: false,
      })
      .then(data => {
        return data;
      });
    return json;
  };

  // const paid = Boolean(localStorage.getItem(`wr-${imdbID}`) || false);
  // const player = new Plyr('#player');
  // let requestingPayment;

  return (
    <div className="FilmSchedule-container">
      <Button onClick={handleClick} className="rent-button">
        {t(rental ? 'voir-le-film' : 'louer-en-vod')}
      </Button>
    </div>
  );
}

export default WRRenting;
